import type { Op } from 'quill/core';

const isCommentContentEmpty = (content: Op[] | null) => {
  if (!content || content.length === 0) return true;
  return content.length === 1 && content[0]?.insert === '\n';
};

export default isCommentContentEmpty;
